import { getServiceByCustomerID } from '@/modules/Service/services'
import { FieldValues, Path, UseFormReturn } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import AsyncSelectWithServer from '../AsyncSelectWithServer'

interface ServiceSelectProps<T extends FieldValues> {
    customerID: number | null
    control: UseFormReturn<T, any, any>['control']
    name: Path<T>
    multiple?: boolean
    showLabel?: boolean
    disabled?: boolean
    label?: string
    acceptPOC?: boolean
    payload: Object
    onChangeAfterHookForm?: () => void
}

const CustomerServiceSelect = <T extends FieldValues>({
    control,
    name,
    multiple,
    showLabel = true,
    disabled = false,
    label,
    payload,
    onChangeAfterHookForm,
    customerID,
}: ServiceSelectProps<T>) => {
    const { t } = useTranslation()
    return (
        <AsyncSelectWithServer<T>
            label={showLabel ? t(label || 'select-customer') : undefined}
            placeholder={t(label || 'select-customer')}
            control={control}
            name={name}
            queryKey={customerID}
            asyncOptions={(value) => {
                return getServiceByCustomerID({
                    t,
                    payload: {
                        page: 1,
                        page_size: (value?.length || 0) + 5,
                        q: value,
                        ...payload,
                    },
                    customerID: Number(customerID),
                })
            }}
            allowClear={false}
            multiple={multiple}
            onChangeAfterHookForm={onChangeAfterHookForm}
            disabled={disabled}
        />
    )
}

export default CustomerServiceSelect
